import SurgeryObject, { SurgeryObjectType } from '@/models/entities/Objects/SurgeryObject'
import IComment from '@/models/interfaces/sheets/IComment'
import IParameter from '@/models/interfaces/sheets/IParameter'

/**
 * Defines the subtype of a device, which defines where it can be placed
 */
export enum DeviceSubtype {
  CHILD = 'Child',
  COLUMN = 'Column',
  GROUND = 'Ground',
  STAND = 'Stand',
  STAND_AND_COLUMN = 'StandAndColumn',
}

/**
 * Defines a device
 * A device is a generic surgery object that can be placed in specific places.
 */
export class Device extends SurgeryObject {
  brand!: string

  model!: string

  parameters!: IParameter<unknown>[]

  deviceSubtype!: DeviceSubtype

  comments!: IComment[]

  selectedChildDevice?: number

  childDevices?: Device[]

  parentDevice?: Device

  additionalInformation?: {
    location: string;
    representatives: { name: string; tel: string }[];
    experts: string[];
  };


  constructor() {
    super(SurgeryObjectType.DEVICE)
  }

  searchableContent(): string[] {
    // Combine parent's searchable content with device-specific fields
    return [
      ...super.searchableContent?.() || [],
      this.brand,
      this.model,
      // Add more fields if needed
    ];
  }
}

export default Device
